/*
  Fizzy Moo signup pop-up.
  Opens once a discount code is set in the section, after a short delay or once the
  visitor has scrolled a little. Closing it snoozes it for the number of days set in
  the section. After a signup it reopens on the reloaded page to show the code.
  Add ?fm_popup=preview to a page URL to review it without a code.
*/
(function () {
  var SNOOZE_KEY = 'fm_popup_snoozed_until';
  var DONE_KEY = 'fm_popup_signed_up';
  var FORM_HASH = '#FmSignupForm';

  function read(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function write(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      /* storage can be blocked; the pop-up still works for this visit */
    }
  }

  function init(root) {
    if (!root || root.dataset.fmReady === 'true') return;
    root.dataset.fmReady = 'true';

    var dialog = root.querySelector('.fm-popup__dialog');
    var stateEl = root.querySelector('[data-fm-popup-state]');
    var state = stateEl ? stateEl.getAttribute('data-fm-popup-state') : 'form';
    var params = new URLSearchParams(window.location.search);
    var posted = params.get('customer_posted') === 'true';
    var postedHere = posted && window.location.hash === FORM_HASH;
    var preview = params.get('fm_popup') === 'preview';
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    var lastFocus = null;
    var timer = null;
    var isOpen = false;

    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled])'),
        function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0;
        }
      );
    }

    function onKey(event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close(true);
        return;
      }
      if (event.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function open() {
      if (isOpen) return;
      isOpen = true;
      stopWatching();
      lastFocus = document.activeElement;
      root.hidden = false;
      document.documentElement.classList.add('fm-popup-open');
      // Read the layout once so the closed styles apply first and the fade runs.
      // Unlike waiting for a frame, this also works in a background tab.
      void root.offsetWidth;
      root.classList.add('is-open');
      document.addEventListener('keydown', onKey);
      var target =
        root.querySelector('[aria-invalid="true"]') ||
        (state === 'success' ? root.querySelector('[data-fm-copy]') : root.querySelector('input[type="email"]')) ||
        dialog;
      window.setTimeout(function () {
        try {
          target.focus({ preventScroll: true });
        } catch (e) {
          target.focus();
        }
      }, 60);
    }

    function close(snooze) {
      if (!isOpen) return;
      isOpen = false;
      root.classList.remove('is-open');
      root.hidden = true;
      document.documentElement.classList.remove('fm-popup-open');
      document.removeEventListener('keydown', onKey);
      if (snooze && !designMode && !preview) {
        var days = parseInt(root.dataset.snoozeDays, 10) || 14;
        write(SNOOZE_KEY, String(Date.now() + days * 86400000));
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    function busy() {
      // Dawn locks the page while the menu or cart drawer is open.
      return document.body.classList.contains('overflow-hidden') || document.querySelector('details[open].menu-drawer-container');
    }

    function tryOpen() {
      if (isOpen) return;
      if (busy()) {
        if (timer) window.clearTimeout(timer);
        timer = window.setTimeout(tryOpen, 4000);
        return;
      }
      open();
    }

    function onScroll() {
      var scrolled = window.scrollY + window.innerHeight;
      var total = document.documentElement.scrollHeight;
      if (total > 0 && scrolled / total > 0.4) {
        window.removeEventListener('scroll', onScroll);
        tryOpen();
      }
    }

    function stopWatching() {
      if (timer) window.clearTimeout(timer);
      timer = null;
      window.removeEventListener('scroll', onScroll);
    }

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-fm-popup-close]')) {
        event.preventDefault();
        close(true);
        return;
      }
      var copy = event.target.closest('[data-fm-copy]');
      if (copy) {
        var codeEl = root.querySelector('[data-fm-code]');
        var code = codeEl ? codeEl.textContent.trim() : '';
        var done = function () {
          var label = copy.textContent;
          copy.textContent = copy.getAttribute('data-copied-label') || label;
          window.setTimeout(function () {
            copy.textContent = label;
          }, 2000);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(done, function () {});
        }
      }
    });

    document.addEventListener('shopify:section:select', function (event) {
      if (event.target.contains(root)) open();
    });
    document.addEventListener('shopify:section:deselect', function (event) {
      if (event.target.contains(root)) close(false);
    });

    if (postedHere) {
      if (state === 'success') write(DONE_KEY, '1');
      open();
      return;
    }
    if (posted && state === 'success') {
      // Signed up through another form on the page, so do not ask again.
      write(DONE_KEY, '1');
      return;
    }
    if (preview) {
      window.setTimeout(open, 400);
      return;
    }
    if (designMode) return;
    if (root.dataset.enabled !== 'true' || root.dataset.offerReady !== 'true') return;
    if (read(DONE_KEY) === '1') return;
    var until = parseInt(read(SNOOZE_KEY), 10);
    if (until && until > Date.now()) return;

    var delay = (parseInt(root.dataset.delay, 10) || 8) * 1000;
    timer = window.setTimeout(tryOpen, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fm-popup]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-fm-popup]');
    if (root) init(root);
  });
})();
